export class CoreTeam {
  [key: string]: any;
  _id?: string;
  _rev?: string;
  type?: string = "coreTeam";
  options?: string[] = [];
}